<template slot-scope="scope">
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column
          label="投诉目标/ID"
          align="center"
          width="210"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.targetName }}<br/>({{ scope.row.targetCode }})</span>
          </template>
        </el-table-column>
        <el-table-column
          label="投诉状态"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == '0'" style="color: #3492f8"
              >完成</span
            >
            <span v-if="scope.row.status == '1'" style="color: #e99d42"
              >处理中</span
            >
            <span v-if="scope.row.status == '3'" style="color: #bd3124"
              >投诉人待确认</span
            >
            <span v-if="scope.row.status == '4'" style="color: #bd3124"
              >被投诉人待确认</span
            >
            <span v-if="scope.row.status == '2'" style="color: #898989"
              >撤销
            </span>
          </template>
        </el-table-column>
        <el-table-column label="投诉结果" align="center" width="150" >
          <template slot-scope="scope">
            <span v-if="scope.row.status == '2'" style="color: #898989"
              >撤销
            </span>
            <span
              v-if="
                scope.row.status == '0' ||
                scope.row.status == '3' ||
                scope.row.status == '4'
              "
              style="color: #3492f8; cursor: pointer"
              @click="handelView(scope.$index, scope.row, 1)"
              >查看处理结果
            </span>
          </template>
        </el-table-column>
        <el-table-column label="投诉时间" align="center" width="150" >
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.status != '2'"
              class="table-p"
              @click="handelViewConte(scope.$index, scope.row, 5)"
              >查看投诉内容</span
            >
            <span
              v-if="scope.row.status == '1'"
              class="table-p"
              @click="handelView(scope.$index, scope.row, 3)"
              >撤销</span
            >
            <span
              v-if="scope.row.status == '1' && scope.row.submitCount != '1'"
              class="table-p"
              @click="handelConentFill(scope.$index, scope.row, 4)"
              >补充内容</span
            >
            <span
              v-if="scope.row.status == '1' && scope.row.submitCount == '1'"
              class="table-p table-added"
              >补充内容</span
            >
            <span
              v-if="scope.row.status == '3'"
              class="table-p"
              @click="handelView(scope.$index, scope.row, 2)"
              >确认处理结果</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 查看/确认处理结果 -->
    <result
      :ProcessingResult="ProcessingResult"
      :dialogVisible="dialogVisible"
      :result="result"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></result>
    <!-- 补充内容 -->
    <contentFill
      :dialogContent="dialogContent"
      :result="result"
      :compId="compId"
      :type="0"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></contentFill>
    <!-- 投诉申诉内容 -->
    <viewConte
      :dialogView="dialogView"
      :result="result"
      :contentList="contentList"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></viewConte>
  </div>
</template>

<script>
// 引入接口
import {
  getComplaintInfo, //查看投诉 申诉内容
  revokeComplaint, // 撤销投诉
  confirmComplaintResult, // 确认处理结果
} from "../../../../../assets/api/firm/firmCenter";
import result from "./result.vue";
import contentFill from "./contentFill.vue";
import viewConte from "./viewContet.vue";
export default {
  props: {
    tableData: {},
    select: {},
  },
  components: {
    result,
    contentFill,
    viewConte,
  },
  data() {
    return {
      dialogVisible: false, //处理结果查看与确认
      result: "1", // 1查看结果  2确认结果 3撤销 4补充内容 5投诉申诉
      dialogContent: false, // 补充内容
      dialogView: false, // 查看投诉/申诉内容
      keyId: "", // 投诉主键id、
      contentList: [], // 查看投诉申诉内容 数据
      compId: "", // 传给子组件的数据  补充内容接口所需的主键id
      ProcessingResult: {}, // 传给处理结果的数据
    };
  },
  computed: {},
  created() {},
  methods: {
    // ---------------查看投诉 申诉 内容
    async getComplaintInfo() {
      var data = {
        data: {
          id: this.keyId, // 投诉主键id
        },
      };
      // 调用 投诉 申诉内容接口
      const res = await getComplaintInfo(data);
      var obj = {
        attachmentId: res.data.attachmentId,
        attachmentName: res.data.attachmentName,
        createTime: res.data.createTime,
        content: res.data.content,
        type: 0,
      };
      // 将投诉申诉的内容 赋值给 this.contentList 用于传给组件进行展示
      this.contentList = res.data.complaintExtendList;
      this.contentList.unshift(obj);
    },
    //查看 投诉/申诉内容
    handelViewConte(index, row, num) {
      if (!this.$checkAction()) return;
      this.result = "5";
      this.keyId = row.id;
      this.getComplaintInfo();
      this.dialogView = true;
    },
    // 补充内容
    handelConentFill(index, row, num) {
      if (!this.$checkAction()) return;
      this.result = "4";
      this.compId = row.id;
      this.dialogContent = true;
    },
    // 查看处理结果
    handelView(index, row, num) {
      if (!this.$checkAction()) return;
      console.log(row, "row");
      this.ProcessingResult = row;
      this.dialogVisible = true;
      // 点击操作时先获取主键id  原告id 被告id
      this.keyId = row.id;
      if (num == 1) {
        this.result = "1";
      } else if (num == 2) {
        this.result = "2";
      } else if (num == 3) {
        this.result = "3";
      }
    },
    // 弹窗关闭
    handleClose(val) {
      if (val == 1 || val == 2 || val == 3) {
        this.dialogVisible = false;
      } else if (val == 4) {
        this.dialogContent = false;
      } else if (val == 5) {
        this.dialogView = false;
      }
    },
    // 弹窗确认
    handleUnderstand(val) {
      if (val == 1) {
        // 确认查看结果
        this.dialogVisible = false;
      } else if (val == 2) {
        //确认结果
        var data = {
          data: {
            sourceId: this.ProcessingResult.sourceId, //原告id
            id: this.keyId,
            compPage: 0, // 0投诉  1被投诉
            targetId: this.ProcessingResult.targetId, //被告id
          },
        };
        // 调用确认处理结果接口
        confirmComplaintResult(data).then((res) => {
          if (res.code == 0) {
            // 成功提示
            this.$tool.PromptBox("success", "操作成功");
            // 让父组件刷新数据列表
            this.$emit("RefreshList");
          } else {
            // 报错提示
            // this.$tool.PromptBox("error", res.msg);
          }
        });
        this.dialogVisible = false;
      } else if (val == 3) {
        //撤销投诉
        var data = {
          data: {
            id: this.keyId,
          },
        };
        // 调用撤销接口
        revokeComplaint(data).then((res) => {
          if (res.code == 0) {
            // 成功提示
            this.$tool.PromptBox("success", "操作成功");
            // 让父组件刷新数据列表
            this.$emit("RefreshList");
          } else {
            // 报错提示
            // this.$tool.PromptBox("error", res.msg);
          }
        });
        // 关闭弹窗
        this.dialogVisible = false;
      } else if (val == 4) {
        //补充内容
        this.dialogContent = false;
        // 让父组件刷新数据列表
        this.$emit("RefreshList");
      } else if (val == 5) {
        //查看 投诉/申诉内容
        this.dialogView = false;
        // 让父组件刷新数据列表
        this.$emit("RefreshList");
      }
    },
    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}
::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
::v-deep .el-table__body-wrapper {
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}
.table-p {
  display: inline-block;
  width: 75px;
  height: 24px;
  border-radius: 5px;
  background: #409eff ;
  text-align: center;
  color: #ffffff;
  line-height: 24px;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: #ffffff;
  text-align: center;
  font-weight: 400;
  margin-right: 10px;
  cursor: pointer;
}
.table-added {
  // box-sizing: border-box;
  background: #eeeeee;
  border: 1px solid #999999;
  color: #666666;
  height: 22px;
  line-height: 22px;
}
/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(5) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-last-child(1) {
//   border-radius: 0 10px 0 0 !important;
// }

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
